
import {
    Add, Edit, Delete, Schedule, Refresh, CheckCircle, Cancel,
    Pending, Warning, History as HistoryIcon, CloudUpload as UploadIcon,
    Note as NoteIcon, AttachMoney, FilterList
} from '@mui/icons-material';

export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4'];

export const STATUS_COLORS = {
    completed: '#4CAF50',
    scheduled: '#2196F3',
    cancelled: '#F44336',
    in_progress: '#FF9800',
    no_show: '#9E9E9E'
};

// Status icons
export const STATUS_ICONS = {
    scheduled: <Schedule />,
    in_progress: <Warning />,
    completed: <CheckCircle />,
    cancelled: <Cancel />,
    no_show: <Cancel />,
};